export function LockClosedIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M2.66675 8.66667C2.66675 7.93029 3.2637 7.33333 4.00008 7.33333H12.0001C12.7365 7.33333 13.3334 7.93029 13.3334 8.66667V12.6667C13.3334 13.403 12.7365 14 12.0001 14H4.00008C3.2637 14 2.66675 13.403 2.66675 12.6667V8.66667Z'
        fill='white'
      />
      <path
        d='M5.33341 4.66667C5.33341 3.19391 6.52732 2 8.00008 2C9.47284 2 10.6667 3.19391 10.6667 4.66667V7.33333H5.33341V4.66667Z'
        fill='white'
      />
      <path
        d='M8.00008 10V11.3333M4.00008 14H12.0001C12.7365 14 13.3334 13.403 13.3334 12.6667V8.66667C13.3334 7.93029 12.7365 7.33333 12.0001 7.33333H4.00008C3.2637 7.33333 2.66675 7.93029 2.66675 8.66667V12.6667C2.66675 13.403 3.2637 14 4.00008 14ZM10.6667 7.33333V4.66667C10.6667 3.19391 9.47284 2 8.00008 2C6.52732 2 5.33341 3.19391 5.33341 4.66667V7.33333H10.6667Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  )
}
